﻿const tocCommandBarSectionId = '0AEAF671F8E548C494CCEC8E13F99562';
const sortOrderStep = 128;
const getItemWithChanges = (itemId, state) => {
	const { tocData, changes } = state;
	const item = tocData.get(itemId);
	const itemChanges = changes[itemId];
	return { ...item, ...itemChanges };
};
const getChildrenWithChanges = (state, parentId) => {
	const { tocData, changes } = state;
	const newData = new Map([...tocData]);
	for (const [id, change] of Object.entries(changes)) {
		const oldItem = tocData.get(id);
		if (!oldItem) {
			newData.set(id, change);
			continue;
		}

		newData.set(id, { ...oldItem, ...change });
	}

	const children = [];
	newData.forEach((relshipItem) => {
		if (relshipItem['@odata.type'] !== '#CommandBarSectionItem') {
			return;
		}

		const relatedId = relshipItem.related_id;
		const relatedItem = newData.get(relatedId);
		const isChild = relatedItem['parent_menu@aras.id'] === parentId;
		if (!isChild) {
			return;
		}

		const changedRelship = newData.get(relshipItem.id);
		children.push(changedRelship);
	});

	return children;
};

const addItemChanges = (id, itemChanges, state) => {
	const existingChange = state.changes[id];
	if (existingChange) {
		state.changes[id] = {
			...existingChange,
			...itemChanges
		};
	} else {
		state.changes[id] = {
			'@aras.action': 'edit',
			...itemChanges
		};
	}
};

export default (setState) => {
	return {
		editItem: (id, itemChanges) => {
			setState((state) => addItemChanges(id, itemChanges, state));
		},
		deleteItem: (id) => {
			setState((state) => {
				const deletedItem = getItemWithChanges(id, state);
				const isNewItem = deletedItem['@aras.action'] === 'add';

				if (isNewItem) {
					delete state.changes[id];
				} else {
					state.changes[id] = {
						'@aras.action': 'delete'
					};
				}

				const relatedId = deletedItem.related_id;
				const relatedItem = getItemWithChanges(relatedId, state);
				const isFolderDeleted =
					relatedItem['@odata.type'] === '#CommandBarMenu';
				if (isFolderDeleted) {
					const newParentId = relatedItem['parent_menu@aras.id'];
					const newItems = Object.values(state.changes).filter(
						(itemChanges) => itemChanges['@aras.action'] === 'add'
					);
					const allItems = [...state.tocData.values(), ...newItems];

					allItems.forEach(({ id, '@odata.type': type }) => {
						const isRelshipItem = type === '#CommandBarSectionItem';
						if (isRelshipItem) {
							return;
						}

						const item = getItemWithChanges(id, state);
						const parentId = item['parent_menu@aras.id'];
						const isChildOfDeletedFolder = parentId === relatedId;
						if (isChildOfDeletedFolder) {
							const itemChanges = { 'parent_menu@aras.id': newParentId };
							addItemChanges(id, itemChanges, state);
						}
					});
				}
			});
		},
		discardChanges: () => {
			setState((state) => {
				state.changes = {};
				state.selectedId = '';
			});
		},
		addRelationshipItem: (props) => {
			const relationshipItem = {
				action: 'Add',
				'@aras.action': 'add',
				'@odata.type': '#CommandBarSectionItem',
				id: aras.generateNewGUID(),
				source_id: tocCommandBarSectionId,
				...props
			};
			setState((state) => {
				const { id, related_id: relatedId } = relationshipItem;
				state.changes[id] = relationshipItem;
				const { selectedId } = state;
				if (!selectedId) {
					const roots = getChildrenWithChanges(state);
					relationshipItem.sort_order = roots.length * sortOrderStep;
					return;
				}

				const relatedItem = state.changes[relatedId];
				const selectedRelationshipItem = getItemWithChanges(selectedId, state);
				const { related_id: selectedRelatedId } = selectedRelationshipItem;
				const selectedRelatedItem = getItemWithChanges(
					selectedRelatedId,
					state
				);
				if (selectedRelatedItem['@odata.type'] === '#CommandBarMenu') {
					const { id: parentId } = selectedRelatedItem;
					relatedItem['parent_menu@aras.id'] = parentId;
					const children = getChildrenWithChanges(state, parentId);
					relationshipItem.sort_order = children.length * sortOrderStep;
				} else {
					const parentId = selectedRelatedItem['parent_menu@aras.id'];
					const children = getChildrenWithChanges(state, parentId);
					const { sort_order: selectedSortOrder } = selectedRelationshipItem;
					children.forEach((relship) => {
						const { id, sort_order: sortOrder } = relship;
						if (sortOrder > selectedSortOrder) {
							const change = { sort_order: sortOrder + sortOrderStep };
							addItemChanges(id, change, state);
						}
					});

					relatedItem['parent_menu@aras.id'] = parentId;
					relationshipItem.sort_order = selectedSortOrder + sortOrderStep;
				}
			});

			return relationshipItem;
		},
		addRelatedItem: (props) => {
			const relatedItem = {
				'@aras.action': 'add',
				id: aras.generateNewGUID(),
				...props
			};
			setState((state) => {
				state.changes[relatedItem.id] = relatedItem;
			});

			return relatedItem;
		},
		selectItem: (id) => {
			setState((state) => {
				state.selectedId = id;
			});
		}
	};
};
